import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import './ItemMarquee.css';

function ItemMarquee({ items, direction }) {
    if (!items || items.length === 0) {
        return <Typography sx={{ fontStyle: 'italic', color: 'text.secondary' }}>No recent items to display.</Typography>;
    }

    // Duplicate items to create a seamless loop
    const extendedItems = [...items, ...items];

    return (
        <div className="marquee-container">
            <div className={`marquee-content ${direction}`}>
                {extendedItems.map((item, index) => (
                    <Paper key={`${item._id}-${index}`} className="marquee-item" elevation={2}>
                        <Box
                            component="img"
                            src={item.image || 'https://via.placeholder.com/150?text=No+Image'}
                            alt={item.itemName}
                            className="marquee-image"
                        />
                        <Typography className="marquee-text">{item.itemName}</Typography>
                    </Paper>
                ))}
            </div>
        </div>
    );
}

export default ItemMarquee;
